// extracted by mini-css-extract-plugin
export default {"form":"Form_form__7-ay9","miniTopPadding":"Form_miniTopPadding__nKZeF","vertical":"Form_vertical__+NSL5","spin":"Form_spin__PsntP","description":"Form_description__3E5qD"};